// Meta Pixel utility
export const PIXEL_ID = '1200862856432658'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

function ensureFbqStub() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
}

export function initMetaPixel() {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return
    if (initialized) return

    ensureFbqStub()

    // Inject the script tag if not already present
    const existing = document.querySelector(
      'script[src*="connect.facebook.net"]',
    )
    if (!existing) {
      const target = document.head || document.body || document.documentElement
      if (target) {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://connect.facebook.net/en_US/fbevents.js'
        target.appendChild(script)
      }
    }

    window.fbq('init', PIXEL_ID)
    initialized = true
    console.log('[Meta Pixel] Initialized with ID:', PIXEL_ID)
  } catch (err) {
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackPageView() {
  try {
    ensureFbqStub()
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
    console.log('[Meta Pixel] PageView tracked')
  } catch (err) {
    console.warn('Meta Pixel PageView failed:', err)
  }
}

export function trackAddToCart(data?: {
  content_name?: string
  value?: number
  currency?: string
}) {
  try {
    ensureFbqStub()
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'AddToCart', data)
    console.log('[Meta Pixel] AddToCart tracked', data)
  } catch (err) {
    console.warn('Meta Pixel AddToCart failed:', err)
  }
}
